
const tabsGroup: any = {
    "key-data": [
        {
            avgKey: "quality",
            shotKey: "shotQuality"
        },
        {
            avgKey: "distanceToPin",
            shotKey: "distanceToPinConverted",
            round: 0
        },
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted",
            round: 1
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2
        },
        {
            avgKey: "launchAngle",
            shotKey: "launchAngleConverted"
        },
        // {
        //     avgKey: "side",
        //     shotKey: "sideConverted"
        // }
    ],
    "club-data": [
        {
            avgKey: "quality",
            shotKey: "shotQuality"
        },
        // {
        //     avgKey: "carryDistance",
        //     shotKey: "carryDistanceConverted"
        // },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2
        },
        {
            avgKey: "clubPath",
            shotKey: "clubPathConverted"
        },
        {
            avgKey: "faceAngle",
            shotKey: "faceAngleConverted"
        },
        {
            avgKey: "faceToPath",
            shotKey: "faceToPathConverted"
        },
        {
            avgKey: "attackAngle",
            shotKey: "attackAngleConverted"
        }
    ],
    "ball-data": [
        {
            avgKey: "quality",
            shotKey: "shotQuality"
        },
        // {
        //     avgKey: "carryDistance",
        //     shotKey: "carryDistanceConverted"
        // },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "spinAxis",
            shotKey: "spinAxisConverted"
        },
        {
            avgKey: "apex",
            shotKey: "apexConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "launchAngle",
            shotKey: "launchAngleConverted"
        },
        {
            avgKey: "horizontalLaunchAngle",
            shotKey: "horizontalLaunchAngleConverted"
        },
        {
            avgKey: "side",
            shotKey: "sideConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        }
    ]
}
export const tabsGroupClub: any = {
    "key-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2
        },
        {
            avgKey: "apex",
            shotKey: "apexConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        },
        {
            avgKey: "launchAngle",
            shotKey: "launchAngleConverted"
        },
        {
            avgKey: "side",
            shotKey: "sideConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        }
    ],
    "club-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0,
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2,
        },
        {
            avgKey: "clubPath",
            shotKey: "clubPathConverted"
        },
        {
            avgKey: "faceAngle",
            shotKey: "faceAngleConverted"
        },
        {
            avgKey: "faceToPath",
            shotKey: "faceToPathConverted"
        },
        {
            avgKey: "attackAngle",
            shotKey: "attackAngleConverted"
        }
    ],
    "ball-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "spinAxis",
            shotKey: "spinAxisConverted"
        },
        {
            avgKey: "apex",
            shotKey: "apexConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "launchAngle",
            shotKey: "launchAngleConverted"
        },
        {
            avgKey: "horizontalLaunchAngle",
            shotKey: "horizontalLaunchAngleConverted"
        },
        {
            avgKey: "side",
            shotKey: "sideConverted",
            // KWSA-38: one decimal place, trailing zero kept (125 -> 125.0).
            round: 1,
            fixed: true
        }
    ]
}

// KWSA-42: Simulator sessions use their own column order across all three tabs
// (FS-Compete design, Figma node 39544-28825). Every other location keeps
// tabsGroupClub above.
export const tabsGroupSim: any = {
    "key-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "totalDistance",
            shotKey: "totalDistanceConverted",
            round: 1,
            fixed: true
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2
        },
        {
            avgKey: "apex",
            shotKey: "apexConverted",
            round: 1,
            fixed: true
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "spinAxis",
            shotKey: "spinAxisConverted"
        }
    ],
    "club-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "spinAxis",
            shotKey: "spinAxisConverted"
        },
        {
            avgKey: "clubSpeed",
            shotKey: "clubSpeedConverted"
        },
        {
            avgKey: "smashFactor",
            shotKey: "smashFactorConverted",
            round: 2
        },
        {
            avgKey: "clubPath",
            shotKey: "clubPathConverted"
        },
        {
            avgKey: "faceAngle",
            shotKey: "faceAngleConverted"
        },
        {
            avgKey: "faceToPath",
            shotKey: "faceToPathConverted"
        }
    ],
    "ball-data": [
        {
            avgKey: "carryDistance",
            shotKey: "carryDistanceConverted"
        },
        {
            avgKey: "spinRate",
            shotKey: "spinRateConverted",
            round: 0
        },
        {
            avgKey: "spinAxis",
            shotKey: "spinAxisConverted"
        },
        {
            avgKey: "apex",
            shotKey: "apexConverted",
            round: 1,
            fixed: true
        },
        {
            avgKey: "ballSpeed",
            shotKey: "ballSpeedConverted"
        },
        {
            avgKey: "launchAngle",
            shotKey: "launchAngleConverted"
        },
        {
            avgKey: "descentAngle",
            shotKey: "descentAngleConverted"
        },
        {
            avgKey: "horizontalLaunchAngle",
            shotKey: "horizontalLaunchAngleConverted"
        }
    ]
}

export default tabsGroup;